import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { createClient } from "@google/maps";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/core";

import * as wcApi from "../../../services/wcApi";
import * as locationApi from "../../../services/locationApi";
import * as config from "../../../config";
import * as woocommerce from "../../../utils/woocommerce";
import { CircularProgress } from "@material-ui/core";
import { formatAsDay } from "../../../utils/shookit"
import { useWooUser } from "../../../utils/authentication/WooUserContext";
import { fetchAvailableTimeSlots } from "../../../services/locationApi";
import { STORE_ID } from "../../../config";

const useStyles = makeStyles(theme => ({
  buttonPadding: {
    padding: "5px 16px",
    "&:hover": { padding: "5px 16px" }
  }
}));

const NewOrderDialog = ({ customer, onClose, open, addToast, role }) => {
  const wooUser = useWooUser();
  const customerMeta = woocommerce.flattenMetadata(customer)
  const classes = useStyles();
  const googleMapsClient = createClient({ key: config.GOOGLE_MAP_API_KEY });
  const history = useHistory();

  const maxDatesToShow = 7;
  const [availableTimeslots, setAvailableTimeslots] = useState([]);
  const [selectedWindow, setSelectedWindow] = useState(null);
  const [selectedTs, setSelectedTs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [shookitSiteId, setShookitSiteId] = useState(null);
  const [geoError, setGeoError] = useState(null);
  const [shippingAutoFill, setShippingAutoFill] = useState(null);
  const [billingAutofill, setBillingAutofill] = useState(null);

  const getAvailableTimeslots = async () => {
    const response = await locationApi.fetchAvailableTimeSlots(STORE_ID, customer.shipping.city);
    if (response.status === 200) {
      setAvailableTimeslots(response.data);
    } else {
      setGeoError({ message: "Failed to load site information" });
    }
  }

  const onCancelClicked = e => {
    if (onClose) {
      onClose(e);
    }
  };

  const selectWindowSlot = timeslot => {
    setSelectedWindow(timeslot);
    setSelectedTs(null);
  };

  const isSameDate = (date1, date2) => {
    if(!date1 || !date2)
      return ;

    const _date1 = new Date(date1);
    const _date2 = new Date(date2);

    return _date1.getFullYear() === _date2.getFullYear() &&
           _date1.getMonth() === _date2.getMonth() &&
           _date1.getDate() === _date2.getDate();
  }

  const createNewOrder = async () => {
    if(!selectedTs)
      return;

    let leaveAtDoor = selectedTs?.window === 'evening' ? 1 : 0;
    const [selectedTsStart, selectedTsEnd] = selectedTs.time.split('-').map(ts=> ts?.trim ? ts.trim() : ts);

    let additional_data = {};
    try {
      let meta_data = [
        {
          key: "_shipping_lat",
          value: null
        },
        {
          key: "_billing_autofill_checkout",
          value: billingAutofill
        },
        {
          key: "_shipping_autofill_checkout",
          value: shippingAutoFill
        },
        {
          key: "_shipping_long",
          value: null
        },
        {
          key: "Shookit Site",
          value: shookitSiteId
        },
        {
          key: "Shookit Timeslot Start",
          value: selectedTsStart
        },
        {
          key: "Shookit Timeslot End",
          value: selectedTsEnd
        },
        {
          key: "Shookit Timeslot Date",
          value: new Date(selectedWindow.date).toISOString()
        },
        {
          key: "_draft_order",
          value: "1"
        },
        {
          key: "_created_by_admin",
          value: wooUser.id
        },
        {
          key: "force_free_shipping", // for manually created orders free shipping is forced
          value: "1"

        },
        {
          key: "leave_at_door",
          value: leaveAtDoor
        },
        {
          key: "building_code",
          value: customerMeta.building_code ? customerMeta.building_code : ''
        },
        {
          key: "shipping_address_street",
          value: customerMeta.shipping_address_street ? customerMeta.shipping_address_street : ''
        },
        {
          key: "shipping_address_street_number",
          value: customerMeta.shipping_address_street_number ? customerMeta.shipping_address_street_number : ''
        },

      ];

      // CreditGuard
      if (customer['creditguard-authorization']) {
        setMetaKey(meta_data, "_creditguard_token", customer['creditguard-token']);
        setMetaKey(meta_data, "_creditguard_expiration", customer['creditguard-expiration']);
        setMetaKey(meta_data, "_ccnumber", customer['creditguard-number']);
        setMetaKey(meta_data, "_payments", 1);
        setMetaKey(meta_data, "_first_payment", "0");
        setMetaKey(meta_data, "_periodical_payment", "");
        setMetaKey(meta_data, "creditguard_authorization", customer['creditguard-authorization']);
        setMetaKey(meta_data, "_payment_gateway", 'CreditGuard');
        setMetaKey(meta_data, "creditguard_token", customer['creditguard-token']);
        setMetaKey(meta_data, "creditguard_expiration", customer['creditguard-expiration']);
        setMetaKey(meta_data, "creditguard_payments", 1);
        setMetaKey(meta_data, "order_first_payment", "0");
        setMetaKey(meta_data, "order_periodical_payment", "");
        setMetaKey(meta_data, "creditguard_authorization", customer['creditguard-authorization']);
        setMetaKey(meta_data, "payment_gateway", 'CreditGuard');
        additional_data = {
          payment_method: "creditguard",
          payment_method_title: "תשלום באמצעות קרדיטגארד",
        }
      }

      let result = await wcApi.createNewOrder(customer, meta_data, additional_data);
      window.location.reload();

      // history.push(`/order/${result.data.id}`);
    } catch (err) {
      console.log(err);
      // addToast({variant: 'error', message: err.response.message})
    }
  };

  const setMetaKey = (meta_data, key, value) => {
    meta_data.push({
      key: key,
      value: value
    });
  }

  const selectTs = ts => {
    setSelectedTs(ts);
  };

  useEffect(() => {
    if (!customer?.id)
      return;

    getAvailableTimeslots()
      .then(() => {
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }, [customer?.id]);

  if (isLoading) {
    return (
      <Dialog open={open} onClose={onCancelClicked} maxWidth="lg">
        <DialogTitle>Create new Order For User</DialogTitle>
        <DialogContent>
          <CircularProgress/>
        </DialogContent>
      </Dialog>
    );
  }

  if (geoError) {
    return (
      <Dialog open={open} onClose={onCancelClicked} maxWidth="lg">
        <DialogTitle>Can not create new</DialogTitle>
        <DialogContent dividers>
          <Typography>
            Due to an errror: <i>{geoError.message}</i>
          </Typography>
        </DialogContent>
      </Dialog>
    );
  }

  function renderTimeSlots() {
    const selectedTimeSlot = availableTimeslots
      .find(ts => isSameDate(selectedWindow.date, ts.date));

    if (!selectedTimeSlot?.timeSlots) return;

    return selectedTimeSlot.timeSlots.map(slot =>
      <Grid item key={slot.time}>
        <Button
          className={classes.buttonPadding}
          variant={selectedTs?.time === slot.time && selectedTs?.window === slot.window  ? "outlined" : "text"}
          color={selectedTs?.time === slot.time && selectedTs?.window === slot.window  ? "primary" : "default"}
          onClick={() => selectTs(slot)}>
          {slot.time}
        </Button>
      </Grid>
    )
  }

  return (
    <Dialog open={open} onClose={onCancelClicked} maxWidth="lg">
      <DialogTitle>Create new order</DialogTitle>
      <DialogContent dividers>
        <Typography varian="h4">Select Day</Typography>
        <Grid container direction="row">
          {availableTimeslots?.slice(0, maxDatesToShow).map(ts => (
            <Grid item key={ts.date}>
              <Button
                variant={ isSameDate(selectedWindow?.date, ts.date) ? "outlined" : "text"}
                className={classes.buttonPadding}
                color={isSameDate(selectedWindow?.date, ts.date) ? "primary" : "default"}
                onClick={() => selectWindowSlot(ts)}>
                {formatAsDay(new Date(ts.date))}
              </Button>
            </Grid>
          ))}
        </Grid>
        <br/>
        <Typography varian="h4">Select Time slot</Typography>
        <Grid container direction="column">
          {selectedWindow != null && renderTimeSlots()}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onCancelClicked}>
          Cancel
        </Button>
        <Button
          color="primary"
          type="submit"
          disabled={!selectedTs}
          onClick={createNewOrder}>
          Create Order
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewOrderDialog;
